module.exports = __webpack_public_path__ + "static/media/guiaRoj.4e68bee8.png";